export default __webpack_public_path__ + "static/media/ic_paraguay.7b9805c0.svg";